__turbopack_context__.v({
  "SpecializationCard__InnerImage": "SpecializationCard-module-scss-module__Exet_G__SpecializationCard__InnerImage",
  "SpecializationCard__InnerShowMoreIcon": "SpecializationCard-module-scss-module__Exet_G__SpecializationCard__InnerShowMoreIcon",
  "SpecializationCard__InnerTitle": "SpecializationCard-module-scss-module__Exet_G__SpecializationCard__InnerTitle",
  "SpecializationCard__background": "SpecializationCard-module-scss-module__Exet_G__SpecializationCard__background",
  "specializationsCarousel": "SpecializationCard-module-scss-module__Exet_G__specializationsCarousel",
  "sponsored-image": "SpecializationCard-module-scss-module__Exet_G__sponsored-image",
  "sponsored-image-wrapper": "SpecializationCard-module-scss-module__Exet_G__sponsored-image-wrapper",
  "swiper-slide": "SpecializationCard-module-scss-module__Exet_G__swiper-slide",
});
